export default {
    SELECTED : 'selected',
    ALL_ON_PAGE : 'all_on_page',
    ALL : 'all',
};
